window.mockRequire = f => {
    // console.log('mockRequire', f);
};
